// src/api/index.js
import axios from 'axios';
import { createAppTransport } from '@1823-partners/core';

// Same-origin /api/surveillance: the SWA Function in production, setupProxy.js
// (-> pam-deacon `python -m apps.dev_server surveillance`) under npm start.
const api = createAppTransport({ axios, appName: 'surveillance' });

export const getSurveillance = async (settle_date) => {
  return api.get('/get-surveillance', { params: { settle_date } });
};

export const getSurveillanceRowHistory = async (surveillance_id) => {
  return api.get(`/get-surveillance-row-history?surveillance_id=${surveillance_id}`);
};

export const getSurveillanceDates = async () => {
  return api.get('/surveillance-dates');
};

export const runHistory = async () => {
  return api.get('/run-history');
};

// Runs are queued on Deacon and relayed to a Beacon Bob job. A 202 carries
// { load_id, status: 'REQUESTED', run_type, run_date, accounts, kicked };
// follow it with getRunStatus(load_id). Attribution comes from the verified
// SWA principal server-side — no client-supplied user param.
export const runSurveillance = async (run_date) => {
  return api.post('/run-surveillance', { run_date });
};

// Latest event for one run: { load_id, status, notes, modified_date,
// run_type, run_date, accounts, user }; 404 when the load_id is unknown.
export const getRunStatus = async (load_id) => {
  return api.get(`/run-status/${encodeURIComponent(load_id)}`);
};

export const getCashflows = async (asofdt) => {
  return api.get('/cashflows', { params: { asofdt } });
};

export const getAnalytics = async (asofdt) => {
  return api.get('/analytics', { params: { asofdt } });
};

// Each row carries the MODIFIED_DATE it was loaded with, unchanged (the
// writer's concurrency token); a 200 carries the batch's new `modified_date`.
export const saveSurveillance = async (modifiedRows) => {
  return api.post('/save-surveillance', modifiedRows);
};

export const getAccounts = async () => {
  return api.get('/get-accounts');
};

// Same 202 / 409 / 400 / 503 contract as runSurveillance, for run_type 'Book'.
export const runBook = async (run_date, accounts) => {
  return api.post('/run-book', { run_date, accounts });
};

// Export the api client for direct access if needed
export default api;
